/**
 * Wrapper when we can't use useI18n directly because the composable will be used in middlewares
 * @returns
 */
export function useFormatOptions() {
  const {
    $i18n: { t, te, d: dateFormatI18n, locale, localeCodes, ...othersOptions },
  } = useNuxtApp();

  const formatOptions = computed<I18nFormatOptions>(() => ({
    t,
    te,
    dateFormatI18n,
  }));

  const getAllTranslations = (key: string) => {
    // put the current locale first
    const sortedLocales = [locale.value, ...localeCodes.value.filter((code) => code !== locale.value)];
    return new Map(sortedLocales.filter((locale) => te(key, locale)).map((locale) => [locale, t(key, {}, { locale })]));
  };

  return {
    t,
    /** check if key exists */
    te,
    dateFormatI18n,
    getAllTranslations,
    locale,
    localeCodes,
    ...othersOptions,
    formatOptions,
  };
}
